import { useEffect } from "react"

export default function LayoutMetricsProvider() {
    useEffect(() => {
        const trackHeight = (selector, cssVar, stableFrames = 20) => {
            let lastHeight = 0
            let stableCount = 0
            let rafId

            const tick = () => {
                const el = document.querySelector(selector)
                if (!el) {
                    rafId = requestAnimationFrame(tick)
                    return
                }

                const height = el.getBoundingClientRect().height
                if (height > 0 && (lastHeight === height)) return () => cancelAnimationFrame(rafId);

                if (height !== lastHeight) {
                    lastHeight = height
                    stableCount = 0
                    document.documentElement.style.setProperty(
                        cssVar,
                        `${height}px`
                    )
                } else {
                    stableCount++
                }

                if (stableCount < stableFrames) {
                    rafId = requestAnimationFrame(tick)
                }
            }

            tick()
            return () => cancelAnimationFrame(rafId)
        }

        const cleanups = [
            trackHeight('#launcher', '--height-zendesk'),
        ]

        return () => cleanups.forEach(fn => fn())
    }, [])

    return null
}


// WEBPACK FOOTER //
// ./src/app/components/LayoutMetricsProvider/index.js